import { render, staticRenderFns } from "./PreciosZonasComponent.vue?vue&type=template&id=bb53e038"
import script from "./PreciosZonasComponent.vue?vue&type=script&lang=js"
export * from "./PreciosZonasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports